import type { IDeliveryAddressView } from "@model/DeliveryAddress.model";
import {
  DELIVERY_ADDRESSES_CLEAR,
  DELIVERY_ADDRESSES_SET_ERROR,
  DELIVERY_ADDRESSES_SET_ITEMS,
  DELIVERY_ADDRESSES_SET_LOADING,
} from "../DeliveryAddresses/DeliveryAddressesActionTypes";

export type DeliveryAddressesState = {
  loading: boolean;
  apiError: string | null;
  items: IDeliveryAddressView[];
};

const INITIAL_STATE: DeliveryAddressesState = {
  loading: false,
  apiError: null,
  items: [],
};

export const DeliveryAddressesReducer = (
  state: DeliveryAddressesState = INITIAL_STATE,
  action: any
): DeliveryAddressesState => {
  switch (action.type) {
    case DELIVERY_ADDRESSES_SET_LOADING:
      return {
        ...state,
        loading: action.payload?.loading ?? false,
      };

    case DELIVERY_ADDRESSES_SET_ERROR:
      return {
        ...state,
        apiError: action.payload?.message ?? null,
      };

    case DELIVERY_ADDRESSES_SET_ITEMS:
      return {
        ...state,
        items: action.payload?.items ?? [],
      };

    case DELIVERY_ADDRESSES_CLEAR:
      return INITIAL_STATE;

    default:
      return state;
  }
};
